
























































import Vue, { PropType } from 'vue';
import { OutlinedTextInput } from '@descomplica/vue-components';
import Checkbox from '@/components/Checkbox.vue';
import { EvaluationEnemGrades } from '@/store/modules/admission/state';
import { floatNumberFormatter, limitedFloatNumberFormatter } from '@/helpers/number';

export interface EnemGradesFormEvent {
  grades: EvaluationEnemGrades;
  hasAcceptedToS?: boolean;
  hasErrors: boolean;
}

export default Vue.extend({
  components: { OutlinedTextInput, Checkbox },
  props: {
    currentGrades: {
      type: Object as PropType<EvaluationEnemGrades>,
      default: () => ({} as EvaluationEnemGrades),
    },
    tosAccepted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      grades: {
        languages: this.currentGrades.languages?.toString() || '',
        humanScience: this.currentGrades.humanScience?.toString() || '',
        natureScience: this.currentGrades.natureScience?.toString() || '',
        math: this.currentGrades.math?.toString() || '',
        essay: this.currentGrades.essay?.toString() || '',
      } as Record<keyof EvaluationEnemGrades, string>,
      errors: {
        languages: false,
        humanScience: false,
        natureScience: false,
        math: false,
        essay: false,
      } as Record<keyof EvaluationEnemGrades, boolean>,
      hasAcceptedToS: this.tosAccepted,
      numberMaskFormatter: limitedFloatNumberFormatter,
      tosLink: process.env.VUE_APP_DESCOMPLICA_TOS_LINK,
    };
  },
  methods: {
    emitInputEvent() {
      const grades: EvaluationEnemGrades = Object.entries(this.grades).reduce(
        (acc, [key, value]) => {
          if (value !== '') {
            const grade = Number(value.replace(',', '.'));
            acc[key as keyof EvaluationEnemGrades] = grade;
            this.errors[key as keyof EvaluationEnemGrades] = grade > 1000;
          }
          return acc;
        },
        {} as Record<keyof EvaluationEnemGrades, number>,
      );

      const hasErrors = Object.values(this.errors).some(Boolean);

      const event: EnemGradesFormEvent = { grades, hasAcceptedToS: this.hasAcceptedToS, hasErrors };
      this.$emit('input', event);
    },
    changeHandle(event: any) {
      this.hasAcceptedToS = event.target.checked;
      this.emitInputEvent();
    },
  },
});
